import React, { useState, useEffect, Fragment } from 'react';

import { CardContent, Grid, FormControl, Autocomplete, InputLabel, Select, MenuItem, TextField } from '@mui/material';

import Enumerable from 'linq';

import { ListadoBuscadorCarreras, ListadoBuscadorProgramasAca } from '../../../Actions/Generales/BuscadoresGenericosAction';
import { ListadoSedesVinculadas } from '../../../Actions/Programas/ProgramasSedesAction';
import { obtenerPrograma } from '../../../Actions/Programas/ProgramasAcademicosAction';
import { ObtenerPeriodosAcaActivos } from '../../../Actions/Utilidades/CombosGenericosAction';
import { ObtenerListadoRegistrosGenericos } from '../../../Actions/Utilidades/CodigosSistemaAction';
import { buscarAdmision, ObtenerAdmisionCif } from '../../../Actions/Admisiones/AdmisionesAction';
import { enlistaArrayCodigosMensajesIdiomas } from '../../../Actions/Generales/IdiomasAction';

import CodigosRegistrosGenericos from '../../../Configuracion/Llaves/CodigosRegistrosGenericos';
import { MostrarMensaje } from '../../../Utilidades/ManejoMensajes';

import { StyleHome } from '../../Tool/Style'

import { MOBILE } from '../config';

import { useGlobalState } from '../../../Utilidades/useGlobalState';

import { dispatchAdmision } from '../Context/store';

const Seleccion = ({ 
    deviceIs = "DESKTOP",
    setListaRequisitosAdmision,
    Admision, 
    setAdmision,
    FuncionValidaRequisitosDeAdmision,
    Credenciales,
    SetAdmisionPreExistente,
    AdmisionPreExistente,
    funcionCargaReqPrograma = () => { } }) => {
    
    const { etiquetas, dispatch } = useGlobalState();

    const admisionDispatch = dispatchAdmision()


    const [ListaCarreras, setListaCarreras] = useState([]); // se encarga del recolectar el listado de carreras

    let datosAdmision = null; // se encarga del recolectar el listado de carreras

    const [ListaProgramas, setListaProgramas] = useState([]); // se encarga del recolectar el listado de programas

    const [ListaSedes, setListaSedes] = useState([]); // se encarga del recolectar el listado de sedes

    const [ListaPeriodosAcaAct, setListaPeriodosAcaAct] = useState([]); // se encarga del recolectar los Periodos academicos activos

    const [Carrera, setCarrera] = useState({
        id: '00000000-0000-0000-0000-000000000000',
        dsc: ''
    }); // se encarga del recolectar la carrera

    const [Programa, setPrograma] = useState({
        id: '00000000-0000-0000-0000-000000000000',
        dsc: ''
    }); // se encarga del recolectar el programa

    const [Sede, setSede] = useState({
        id: '00000000-0000-0000-0000-000000000000',
        dsc: ''
    });// se encarga del recolectar la sede

    //const [EstadosAdmisionId, setEstadosAdmisionId] = useState('00000000-0000-0000-0000-000000000000');// se encarga del recolectar el identificador del estado de la admision

    //const [ClasificacionId, setClasificacionId] = useState('00000000-0000-0000-0000-000000000000');// se encarga del recolectar el identificador de la clasificacion

    const [Periodo, setPeriodo] = useState('00000000-0000-0000-0000-000000000000');// se encarga del recolectar el periodo

    const LoadEstadosAdmision = async () => {
        const responseEstadosAdmision = await ObtenerListadoRegistrosGenericos("", CodigosRegistrosGenericos.EstadosAdmision, Credenciales.companyId, Credenciales.userId, "", true);
        if (responseEstadosAdmision.status === 200) //si la respuesta fue existosa
        {
            if (responseEstadosAdmision.data.length > 0) {
           
               // setEstadosAdmisionId(Enumerable.from(responseEstadosAdmision.data).first(x => x.code === 'PENDING').id);
                const stateAdmisionId = Enumerable.from(responseEstadosAdmision.data).first(x => x.code === 'PENDING').id
                admisionDispatch({ type:'changeStateAdmisionId', payload:{ estadosAdmisionId:stateAdmisionId }});
           
            } else {
                admisionDispatch({ type:'changeStateAdmisionId', payload:{ estadosAdmisionId:'00000000-0000-0000-0000-000000000000' }});

                //setEstadosAdmisionId('00000000-0000-0000-0000-000000000000');
            }
        }
        else {
            if (responseEstadosAdmision.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseEstadosAdmision.data.errors);
                MostrarMensaje(dispatch, responseEstadosAdmision.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [responseEstadosAdmision.statusText]);
            }

            admisionDispatch({ type:'changeStateAdmisionId', payload:{ estadosAdmisionId:'00000000-0000-0000-0000-000000000000' }});

            //setEstadosAdmisionId('00000000-0000-0000-0000-000000000000');
        }
    };

    const LoadClasificacion = async () => {
        const responseClasificacion = await ObtenerListadoRegistrosGenericos("", CodigosRegistrosGenericos.ClasificadosAdmision, Credenciales.companyId, Credenciales.userId, "", true);
        if (responseClasificacion.status === 200) //si la respuesta fue existosa
        {
            if (responseClasificacion.data.length > 0) {
               // setClasificacionId(responseClasificacion.data[0].id);
                
               //para cambiar el state clasificacion
                admisionDispatch({ type:'changeClasificationId', payload:{ clasificationId: responseClasificacion.data[0].id }});
           
            } else {

                admisionDispatch({ type:'changeClasificationId', payload:{ clasificationId:'00000000-0000-0000-0000-000000000000' }});

               // setClasificacionId('00000000-0000-0000-0000-000000000000');
            }
        }
        else {
            if (responseClasificacion.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseClasificacion.data.errors);
                MostrarMensaje(dispatch, responseClasificacion.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [responseClasificacion.statusText]);
            }
           // setClasificacionId('00000000-0000-0000-0000-000000000000');
            admisionDispatch({ type:'changeClasificationId', payload:{ clasificationId:'00000000-0000-0000-0000-000000000000' }});

        }
    };

    const obtenerListaCarreras = async (carreraId) => {

        const objetoListaCarrerasRequest = {
            dsc: '',
            cat: '',
            sts: '1',
            companyId: Credenciales.companyId
        };

        return await ListadoBuscadorCarreras(objetoListaCarrerasRequest).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                // se asigna al objeto de variable de estado local la respuesta 
                setListaCarreras(response.data);

                let indice = response.data.findIndex(x => x.id === carreraId);

                if (indice < 0)
                    indice = 0;

                setCarrera({
                    id: response.data[indice].id,
                    dsc: response.data[indice].dsc
                });

                return response.data[indice].id;
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
                setListaCarreras([]);
                setListaProgramas([]);
                setListaSedes([]);
                setListaPeriodosAcaAct([]);
                setCarrera({
                    id: '00000000-0000-0000-0000-000000000000',
                    dsc: ''
                });
                setPrograma({
                    id: '00000000-0000-0000-0000-000000000000',
                    dsc: ''
                });
                setSede({
                    id: '00000000-0000-0000-0000-000000000000',
                    dsc: ''
                });

                setPeriodo('00000000-0000-0000-0000-000000000000');

                admisionDispatch({
                    type:'changeAllSelect',
                    payload:{ 
                        programId:'00000000-0000-0000-0000-000000000000',
                        periodId:'00000000-0000-0000-0000-000000000000',
                        campusId:'00000000-0000-0000-0000-000000000000'
                    }
                });

                return '00000000-0000-0000-0000-000000000000';
            }
        });
    };

    // se realiza el lamado a la funcion del action que va a pedir informaciocn a Api 
    const obtenerListaProgramas = async (carreraid, programaId = '00000000-0000-0000-0000-000000000000') => {
       
        const objetoListar = {
            CareerId: carreraid,
            GradeId: '',
            Dsc: '',
            Sts: '1',
            CampusId: '',
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        return await ListadoBuscadorProgramasAca(objetoListar).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                // se asigna al objeto de variable de estado local la respuesta 
                if (response.data.length > 0) {

                    let indice = response.data.findIndex(x => x.id === programaId);

                    if (indice < 0)
                        indice = 0;

                    setListaProgramas(response.data);

                    setPrograma({
                        id: response.data[indice].id,
                        dsc: response.data[indice].dsc
                    });

                    admisionDispatch({ type:'changeProgramId', payload:{ programId: response.data[indice].id }});

                    return response.data[indice].id;

                } else {
                    setListaProgramas([]);
                    setListaSedes([]);
                    setListaPeriodosAcaAct([]);

                    setPrograma({
                        id: '00000000-0000-0000-0000-000000000000',
                        dsc: ''
                    });
                    setSede({
                        id: '00000000-0000-0000-0000-000000000000',
                        dsc: ''
                    });
                    setPeriodo('00000000-0000-0000-0000-000000000000');

                    admisionDispatch({
                        type:'changeAllSelect',
                        payload:{ 
                            programId:'00000000-0000-0000-0000-000000000000',
                            periodId:'00000000-0000-0000-0000-000000000000',
                            campusId:'00000000-0000-0000-0000-000000000000'
                        }
                    });

                    return '00000000-0000-0000-0000-000000000000';
                }
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
                setListaProgramas([]);
                setListaSedes([]);
                setListaPeriodosAcaAct([]);
                setPrograma({
                    id: '00000000-0000-0000-0000-000000000000',
                    dsc: ''
                });
                setSede({
                    id: '00000000-0000-0000-0000-000000000000',
                    dsc: ''
                });
                setPeriodo('00000000-0000-0000-0000-000000000000');

                admisionDispatch({
                    type:'changeAllSelect',
                    payload:{ 
                        programId:'00000000-0000-0000-0000-000000000000',
                        periodId:'00000000-0000-0000-0000-000000000000',
                        campusId:'00000000-0000-0000-0000-000000000000'
                    }
                });

                return '00000000-0000-0000-0000-000000000000';
            }
        });
    };

    // se realiza el lamado a la funcion del action que va a pedir informaciocn a Api 
    const obtenerListaSedes = async (ProgramaId) => {
        
        const objetoListaSedesRequest = {
            ProgramId: ProgramaId,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        return await ListadoSedesVinculadas(objetoListaSedesRequest).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                // se asigna al objeto de variable de estado local la respuesta 
                if (response.data.length > 0) {
                    setListaSedes(response.data);
                    setSede({
                        id: response.data[0].id,
                        dsc: response.data[0].dsc
                    });

                    admisionDispatch({ type:'changeCampusId', payload:{ campusId: response.data[0].id }});
                    
                    return response.data[0].id;

                } else {
                    setListaSedes([]);
                    setListaPeriodosAcaAct([]);
                    setSede({
                        id: '00000000-0000-0000-0000-000000000000',
                        dsc: ''
                    });
                    setPeriodo('00000000-0000-0000-0000-000000000000');

                    admisionDispatch({
                        type:'changePeriodAndCampus',
                        payload:{ 
                            periodId:'00000000-0000-0000-0000-000000000000',
                            campusId:'00000000-0000-0000-0000-000000000000'
                        }
                    });

                    return '00000000-0000-0000-0000-000000000000';
                }
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
                setListaSedes([]);
                setListaPeriodosAcaAct([]);
                setSede({
                    id: '00000000-0000-0000-0000-000000000000',
                    dsc: ''
                });
                setPeriodo('00000000-0000-0000-0000-000000000000');

                admisionDispatch({
                    type:'changePeriodAndCampus',
                    payload:{ 
                        periodId:'00000000-0000-0000-0000-000000000000',
                        campusId:'00000000-0000-0000-0000-000000000000'
                    }
                });

                return '00000000-0000-0000-0000-000000000000';
            }
        });
    };

    const BuscarTipoPeriodoPrograma = async (idPrograma, idSede) => {
        const responseProgram = await obtenerPrograma(idPrograma);
        if (responseProgram.status === 200) //si la respuesta fue existosa
        {
            await LoadPeriodosAcaActivosTable(idSede, responseProgram.data.apgCodPeriodTypeFk);
        }
        else {
            if (responseProgram.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseProgram.data.errors);
                MostrarMensaje(dispatch, responseProgram.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [responseProgram.statusText]);
            }
            setListaPeriodosAcaAct([]);
        }
    };

    const LoadPeriodosAcaActivosTable = async (idCampus, idTPeriodo) => {
       
        const objetoListar = {
            CampusId: idCampus,
            PeriodTypeId: idTPeriodo,
            UserId: Credenciales.userId,
            HideSubPeriod: true
        };

        const responsePeriodAcaAtc = await ObtenerPeriodosAcaActivos(objetoListar);

        if (responsePeriodAcaAtc.status === 200) //si la respuesta fue existosa
        {

            if (responsePeriodAcaAtc.data.length > 0) {

                let PeriodoSeleccionado = responsePeriodAcaAtc.data[0].id;

                const listPeriodosAcaTemp = responsePeriodAcaAtc.data;

                try {
                    PeriodoSeleccionado = listPeriodosAcaTemp.find(x => x.id === Periodo).id;
                } catch (eer) {
                    PeriodoSeleccionado = responsePeriodAcaAtc.data[0].id;
                }
                setPeriodo(PeriodoSeleccionado);
              
                admisionDispatch({ type:'changePeriodId', payload:{ periodId: PeriodoSeleccionado }});

            }

            setListaPeriodosAcaAct(responsePeriodAcaAtc.data);
        }
        else {
            setListaPeriodosAcaAct([]);
            setPeriodo('00000000-0000-0000-0000-000000000000');
            admisionDispatch({ type:'changePeriodId', payload:{ periodId: '00000000-0000-0000-0000-000000000000' }});

        }
    };

    const ingresarValoresMemoriaAutoCarrera = async (event, newValue) => {
        dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });               

        if (newValue === null || newValue === undefined) {
            setCarrera({
                id: '00000000-0000-0000-0000-000000000000',
                dsc: ''
            });
            setPrograma({
                id: '00000000-0000-0000-0000-000000000000',
                dsc: ''
            });
            setSede({
                id: '00000000-0000-0000-0000-000000000000',
                dsc: ''
            });
            setPeriodo('00000000-0000-0000-0000-000000000000');
            setListaProgramas([]);
            setListaSedes([]);
            setListaPeriodosAcaAct([]);
            setAdmision('00000000-0000-0000-0000-000000000000');

            admisionDispatch({
                type:'changeAllSelectAndAdmission',
                payload:{ 
                    programId:'00000000-0000-0000-0000-000000000000',
                    periodId:'00000000-0000-0000-0000-000000000000',
                    campusId:'00000000-0000-0000-0000-000000000000',
                    admissionId:'00000000-0000-0000-0000-000000000000'
                }
            });

        } else {
            setCarrera({
                id: newValue.id,
                dsc: newValue.dsc
            });
            const programaId = await obtenerListaProgramas(newValue.id);
            if (programaId !== '00000000-0000-0000-0000-000000000000') {
                const sedeId = await obtenerListaSedes(programaId);
                if (sedeId !== '00000000-0000-0000-0000-000000000000') {
                    await BuscarTipoPeriodoPrograma(programaId, sedeId);
                    await existeAdmision(programaId);
                } else {
                    setAdmision('00000000-0000-0000-0000-000000000000');
                    
                    admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});

                }
            } else {
                setAdmision('00000000-0000-0000-0000-000000000000');
                admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});

            }
        }
        dispatch({ type: "CLOSE_LOAD_HOME" });
    };

    const ingresarValoresMemoriaAutoPrograma = async (event, newValue) => {
        dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });
       
        if (newValue === null || newValue === undefined) {
            setPrograma({
                id: '00000000-0000-0000-0000-000000000000',
                dsc: ''
            });
            setSede({
                id: '00000000-0000-0000-0000-000000000000',
                dsc: ''
            });
            setPeriodo('00000000-0000-0000-0000-000000000000');
            setListaSedes([]);
            setListaPeriodosAcaAct([]);
            setAdmision('00000000-0000-0000-0000-000000000000');

            admisionDispatch({
                type:'changeAllSelectAndAdmission',
                payload:{ 
                    programId:'00000000-0000-0000-0000-000000000000',
                    periodId:'00000000-0000-0000-0000-000000000000',
                    campusId:'00000000-0000-0000-0000-000000000000',
                    admissionId:'00000000-0000-0000-0000-000000000000'
                }
            });


        } else {

            setPrograma({
                id: newValue.id,
                dsc: newValue.dsc
            });

            admisionDispatch({ type:'changeProgramId', payload:{ programId: newValue.id }});


            const admId = await existeAdmision(newValue.id);
            if (admId === '00000000-0000-0000-0000-000000000000') {
                const sedeId = await obtenerListaSedes(newValue.id);
                if (sedeId !== '00000000-0000-0000-0000-000000000000') {
                    await BuscarTipoPeriodoPrograma(newValue.id, sedeId);
                } else {
                    setAdmision('00000000-0000-0000-0000-000000000000');
                    admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});
                }
            }
            //else {
            //    setAdmision('00000000-0000-0000-0000-000000000000');
            //}
        }
        dispatch({ type: "CLOSE_LOAD_HOME" });
    };

    const ingresarValoresMemoriaAutoSede = async (event, newValue) => {        
        if (newValue === null || newValue === undefined) {
            setSede({
                id: '00000000-0000-0000-0000-000000000000',
                dsc: ''
            });
            setPeriodo('00000000-0000-0000-0000-000000000000');
            setListaPeriodosAcaAct([]);

            admisionDispatch({
                type:'changePeriodAndCampus',
                payload:{ 
                    periodId:'00000000-0000-0000-0000-000000000000',
                    campusId:'00000000-0000-0000-0000-000000000000'
                }
            });

        } else {
            setSede({
                id: newValue.id,
                dsc: newValue.dsc
            });

            admisionDispatch({
                type:'changeCampusId',
                payload:{ 
                    campusId:newValue.id
                }
            });

            await BuscarTipoPeriodoPrograma(Programa.id, newValue.id);
        }
    };

     useEffect(() => {
         LoadEstadosAdmision();
         LoadClasificacion();
         if(AdmisionPreExistente === false)
            LoadProperties();
    }, []);

    useEffect(() => {
        if (Admision !== '00000000-0000-0000-0000-000000000000') { 
            admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:Admision}});
            SetAdmisionPreExistente(true);
            RecargarAdmisionEstudiante();
            FuncionValidaRequisitosDeAdmision(Admision);

        }
        else {
            //datosAdmision = null;
            admisionDispatch({ type:'changeArray', payload:{ list:[] }});
            admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});

            funcionCargaReqPrograma(Programa.id, Admision);
            setListaRequisitosAdmision([]);
            FuncionValidaRequisitosDeAdmision('00000000-0000-0000-0000-000000000000');
            SetAdmisionPreExistente(false);
        }
    }, [Admision]);

    useEffect(() => {
        funcionCargaReqPrograma(Programa.id, Admision);
    }, [Programa]);

    const RecargarAdmisionEstudiante = async () => {
        const admData = await obtenerAdmision(Admision);
        //datosAdmision = admData;
        if (admData !== null) {
            await obtenerListaCarreras(admData.apgAcaCareerFk);
            await obtenerListaProgramas(admData.apgAcaCareerFk)
            await obtenerListaSedes(admData.admAcaProgramIdFk);
            await BuscarTipoPeriodoPrograma(admData.admAcaProgramIdFk, admData.admGnlCampusIdFk);

            setCarrera({
                id: admData.apgAcaCareerFk,
                dsc: admData.careerName
            });

            setPrograma({
                id: admData.admAcaProgramIdFk,
                dsc: admData.programName
            });

            setSede({
                id: admData.admGnlCampusIdFk,
                dsc: admData.campusName
            });

            setPeriodo(admData.admPeriodIdFk);

            admisionDispatch({
                type:'changeAllSelect',
                payload:{ 
                    programId:admData.admAcaProgramIdFk,
                    periodId:admData.admPeriodIdFk,
                    campusId:admData.admGnlCampusIdFk,
                }
            });

            //FuncionValidaRequisitosDeAdmision(Admision);
        }
    };

    const LoadProperties = async () => {
        const carreraId = await obtenerListaCarreras('00000000-0000-0000-0000-000000000000');
        if (carreraId !== '00000000-0000-0000-0000-000000000000') {
            const programaId = await obtenerListaProgramas(carreraId);
            if (programaId !== '00000000-0000-0000-0000-000000000000') {
                const sedeId = await obtenerListaSedes(programaId);
                if (sedeId !== '00000000-0000-0000-0000-000000000000') {
                    await BuscarTipoPeriodoPrograma(programaId, sedeId);
                    await existeAdmision(programaId);                    
                } else {
                    setAdmision('00000000-0000-0000-0000-000000000000');
                    setListaRequisitosAdmision([]);
                    admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});
                    //FuncionValidaRequisitosDeAdmision('00000000-0000-0000-0000-000000000000');
                }
            } else {
                setAdmision('00000000-0000-0000-0000-000000000000');
                setListaRequisitosAdmision([]);
                admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});

                //FuncionValidaRequisitosDeAdmision('00000000-0000-0000-0000-000000000000');
            }
        } else {
            setAdmision('00000000-0000-0000-0000-000000000000');
            setListaRequisitosAdmision([]);
            admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});

            //FuncionValidaRequisitosDeAdmision('00000000-0000-0000-0000-000000000000');
        }

    };

    async function existeAdmision(programId) {
        if (datosAdmision !== null) {
            if (datosAdmision.admAcaProgramIdFk !== programId)
                return;
        } else {
            const objetoExisteAdmision = {
                CustomerId: Credenciales.customerId,
                ProgramId: programId,
                CompanyId: Credenciales.companyId
            };

            return await buscarAdmision(objetoExisteAdmision).then(response => {
                if (response.status === 200) //si la respuesta fue existosa 
                {
                    setAdmision(response.data);
                    admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:response.data}});

                    return response.data;
                }
                else {
                    if (response.data.errors) {
                        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                    } else {
                        MostrarMensaje(dispatch, 'error', [response.statusText]);
                    }
                    setAdmision('00000000-0000-0000-0000-000000000000');
                    admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});
                    return '00000000-0000-0000-0000-000000000000';
                }
            });
        }
    };

    async function obtenerAdmision(admId) {
        if (admId === '00000000-0000-0000-0000-000000000000' || admId === undefined)
            return null;
        else {
            const objetoAdmision = {
                AdmissionId: admId,
                UserId: Credenciales.userId,
                CompanyId: Credenciales.companyId
            };

            return await ObtenerAdmisionCif(objetoAdmision).then(response => {
                if (response.status === 200) //si la respuesta fue existosa 
                {                    
                    return response.data;
                }
                else {
                    if (response.data.errors) {
                        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                    } else {
                        MostrarMensaje(dispatch, 'error', [response.statusText]);
                    }
                    setAdmision('00000000-0000-0000-0000-000000000000');
                    admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:'00000000-0000-0000-0000-000000000000'}});
                    setListaRequisitosAdmision([]);
                    //FuncionValidaRequisitosDeAdmision('00000000-0000-0000-0000-000000000000');
                    return null;
                }
            });
        }
    };

    return (
        <Fragment>
            <CardContent sx={{ padding: deviceIs === MOBILE ? 0 : 'initial' }}>
                <Grid container style={deviceIs === MOBILE ? {}: StyleHome.GridConteiner}>
                    <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
                        <FormControl fullWidth variant="outlined">
                            <Autocomplete
                                disabled={ListaCarreras.length === 0}
                                autoHighlight
                                noOptionsText={etiquetas.General.Et_tblSinOpciones}
                                value={Carrera}
                                labelId="CarreraId-label"
                                label={etiquetas.Home.Et_lblAdmisionProgramas + ' *'}
                                options={ListaCarreras}
                                onChange={ingresarValoresMemoriaAutoCarrera}
                                getOptionLabel={(option) => option.dsc}
                                renderInput={(params) => <TextField {...params} labelId="CampusId-label" label={etiquetas.Home.Et_lblAdmisionProgramas + ' *'} />}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
                        <FormControl fullWidth variant="outlined">
                            <Autocomplete
                                disabled={ListaProgramas.length === 0}
                                autoHighlight
                                noOptionsText={etiquetas.General.Et_tblSinOpciones}
                                value={Programa}
                                labelId="ProgramaId-label"
                                label={etiquetas.Home.Et_lblAdmisionPlanes + ' *'}
                                options={ListaProgramas}
                                onChange={ingresarValoresMemoriaAutoPrograma}
                                getOptionLabel={(option) => option.dsc}
                                renderInput={(params) => <TextField {...params} labelId="CampusId-label" label={etiquetas.Home.Et_lblAdmisionPlanes + ' *'} />}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} style={StyleHome.GridItem}>
                        <FormControl fullWidth variant="outlined">
                            <Autocomplete
                                disabled={ListaSedes.length === 0 || Admision !== '00000000-0000-0000-0000-000000000000'}
                                autoHighlight
                                noOptionsText={etiquetas.General.Et_tblSinOpciones}
                                value={Sede}
                                labelId="CampusId-label"
                                label={etiquetas.General.Et_tblSedes + ' *'}
                                options={ListaSedes}
                                onChange={ingresarValoresMemoriaAutoSede}
                                getOptionLabel={(option) => option.dsc}
                                renderInput={(params) => <TextField {...params} labelId="CampusId-label" label={etiquetas.General.Et_tblSedes + ' *'} />}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} style={StyleHome.GridItem}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="PeriodId-label">{etiquetas.General.Et_tblPeriodo + ' *'}</InputLabel>
                            <Select name="PeriodId"
                                disabled={ListaPeriodosAcaAct.length === 0 || Admision !== '00000000-0000-0000-0000-000000000000'}
                                value={Periodo}
                                onChange={(e) => {
                                    setPeriodo(e.target.value);
                                }}
                                labelId="PeriodId-label"
                                label={etiquetas.General.Et_tblPeriodo + ' *'}
                            >
                                {ListaPeriodosAcaAct.map((periodAcaAct) => (<MenuItem key={"ident-" + periodAcaAct.id} value={periodAcaAct.id}>{periodAcaAct.dsc}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        </Fragment>
    );
};

export default Seleccion;